import { FormulaForm } from '@monorepo/shared/componentsV2/formula/FormulaForm';
import { Loading } from '@monorepo/shared/componentsV2/Loading';
import { FormulaStepTokenList } from '@monorepo/workflowDataSetup/src/components/EditWorkflowStepsPage/EditFormulaStepModal/FormulaStepTokenList';
import { FormulaWorkflowStepResponse, WorkflowResponse } from 'mapistry-shared';
import React from 'react';
import { useDatasetSampleFormulaTerms } from '../../../hooks/useDatasetSampleFormulaTerms';
import { findStepById, findStepInputDataset } from '../stepUtils';

interface EditFormulaStepFormProps {
  workflow: WorkflowResponse;
  stepId?: string;
}

export function EditFormulaStepForm({
  workflow,
  stepId,
}: EditFormulaStepFormProps) {
  const step = findStepById(workflow, stepId) as
    | FormulaWorkflowStepResponse
    | undefined;
  const stepInputDataset = findStepInputDataset(workflow, stepId);
  const { datasetSampleFormulaTerms, isLoading, isStale, isFetching } =
    useDatasetSampleFormulaTerms({
      datasetId: stepInputDataset.id,
      organizationId: workflow.organizationId,
    });
  const { schemaProperties } = stepInputDataset;

  // when changing an upstream step's joinToPrefix, we can't
  // render the formula until the new sampleFormulaTerms have fully loaded
  if (isLoading || isStale || isFetching) {
    return <Loading />;
  }

  return (
    <FormulaForm
      sampleFormulaTerms={datasetSampleFormulaTerms}
      tokenList={
        <FormulaStepTokenList stepInputDatasetProperties={schemaProperties} />
      }
      savedFormulaOutputUnits={step?.operationConfig.outputUnits}
    />
  );
}
